export const FORM_FIELDS_MAP = {
  name: {
    key: 'name'
  },
  parentFolder: {
    key: 'parentFolder'
  },
  privacyScope: {
    key: 'scope'
  },
  addEmployees: {
    key: 'addEmployees'
  },
  addHiringAuthorities: {
    key: 'addHiringAuthorities'
  },
  extractContacts: {
    key: 'extractContacts'
  },
  isMasterList: {
    key: 'isMasterList'
  },
  geoPolygon: {
    key: 'geoPolygon'
  },
  seatCount: {
    key: 'seatCount'
  },
  owner: {
    key: 'owner'
  },
  specialty: {
    key: 'specialty',
    paramKey: 'specialtyId',
    inboundAccesor: 'specialty',
    outboundAccesor: 'id'
  },
  subspecialty: {
    key: 'subspecialty',
    paramKey: 'subSpecialtyId',
    inboundAccesor: 'subspecialty',
    outboundAccesor: 'id'
  },
  position: {
    key: 'position',
    paramKey: 'positionId',
    inboundAccesor: 'position',
    outboundAccesor: 'id'
  },
  prospectType: {
    key: 'prospectType'
  },
  skipDuplicates: {
    key: 'skipDuplicates'
  }
};
